/**
 * Whether peak bagging's web surface is public to this viewer.
 *
 * The backend ships ahead of the launch so the peak import and the recordings
 * backfill can run against production, but nobody should find the feature in
 * the meantime. The server pages 404 themselves (PeakListsController,
 * UsersController#peaks) — this is what the Vue side has to go on.
 *
 * It cannot ask GraphQL: the peak queries answer regardless, because shipped
 * iOS builds depend on them and hiding the web surface must not break the apps.
 * So Rails writes the answer into the page — see layouts/_user_json_window,
 * which renders `PeakBagging.visible_to?(current_user)` — and this reads it.
 *
 * Read per call rather than captured at module load: the entrypoints are
 * bundled once and a stale capture would freeze the answer for the session.
 */
export function peakBaggingWebVisible(): boolean {
  return !!(window as unknown as { peakBaggingWeb?: unknown }).peakBaggingWeb;
}
